'use client';

import { useQuery } from '@tanstack/react-query';
import { apiService } from '../../../services/ApiService';
import Loader from '../../components/svg/Loader';
import Poll from '../../components/Poll';

export default function PollWrapper({id}:{id: string}) {
  const {
    data,
    isLoading,
    isPending
  } = useQuery({
    staleTime: 0,
    gcTime: 0,
    queryKey: ['post-poll', id],
    queryFn: () => {
      const deviceId = localStorage.getItem('deviceId') as string;
      return apiService.getPostPoll(id, deviceId)
    }
  });

  if (isLoading || isPending) return <Loader className='mx-auto my-[24px]'/>;

  if (!data) return null;
  return <Poll data={{poll: data, pollUniqueCode: data.uniqueCode}}/>
}